import React from "react";
import LegalLayout from "../../components/layout/LegalLayout";

const PopiaPage: React.FC = () => (
  <LegalLayout>
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-blue-700 mb-6">POPIA Notice</h1>
        <p className="text-gray-700 mb-4">
          The Protection of Personal Information Act (POPIA) is South Africa’s data privacy law. TyreLink is committed to protecting your personal information and complying with POPIA.
        </p>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">1. What is POPIA?</h2>
        <p className="text-gray-700 mb-4">
          POPIA regulates how South African businesses collect, use, store, and share your personal information. It gives you rights over your data and requires us to process your information lawfully and transparently.
        </p>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">2. Your Rights Under POPIA</h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li>To know what personal information we collect and why</li>
          <li>To access, correct, or delete your information</li>
          <li>To object to certain types of processing</li>
          <li>To lodge a complaint with the Information Regulator</li>
        </ul>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">3. How We Protect Your Data</h2>
        <p className="text-gray-700 mb-4">
          We use secure systems and processes to protect your data. Only authorized personnel have access, and we never sell your information.
        </p>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">4. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have questions about your data or this notice, please contact us at support@tyrelink.app.
        </p>
        <p className="text-gray-500 mt-8 text-sm">
          Last updated: July 2025
        </p>
      </div>
    </div>
  </LegalLayout>
);

export default PopiaPage;